// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g1hwM{font-family:Inter,sans-serif;font-weight:400;font-size:16px;line-height:1.5;color:#64748b;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:8px}
.Dmhf7{color:#64748b;font-size:16px !important;margin-top:1px}
.V35fR{color:#64748b;font-size:14px;font-weight:400}
.xh1K7{background:none;border:none;color:#0078d4;font-size:14px;font-weight:500;cursor:pointer;padding:0;text-decoration:underline}
.xh1K7:hover{color:#005a9e}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoText": `g1hwM`,
	"infoIcon": `Dmhf7`,
	"alternativeText": `V35fR`,
	"alternativeLink": `xh1K7`
};
module.exports = ___CSS_LOADER_EXPORT___;
